import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/system'
interface EmptyContainerProps {
  isEmpty?: boolean
}

export const SectionRoot = styled('section')(({ theme }) => ({
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
  margin: '0 auto',
  padding: '1rem',
  [theme.breakpoints.up('xl')]: {
    maxWidth: '1276px',
  },
}))

export const HeaderRoot = styled('header')(({ theme }) => ({
  width: '100%',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
  margin: '0 auto',
  padding: '1rem',
  [theme.breakpoints.up('xl')]: {
    maxWidth: '1276px',
  },
}))

export const ContainerInformation = styled(Box, {
  shouldForwardProp: (propName) => propName !== 'isEmpty',
})<EmptyContainerProps>(({ isEmpty, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: '0.5rem',
  alignItems: 'center',
  marginBottom: '1.5rem',
  marginLeft: isEmpty ? '1rem' : '0',
  [theme.breakpoints.up('sm')]: {
    marginLeft: '0',
    '& > .subtitle': {
      order: 4,
    },
  },
}))
export const TitleText = styled(Typography)(({ theme }) => ({
  lineHeight: '24 / 18',
  fontSize: '1.1rem',
  fontWeight: 600,
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.5rem',
    lineHeight: '32 / 24',
  },
}))
export const CardContainer = styled('ul')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '2rem 1rem',
  padding: 0,
  marginBottom: '0.5rem',
  listStyleType: 'none',
})
